import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SiteHeader from '../SiteHeader/SiteHeader';
import { getToAccounts } from '../../states/accounts/selectors';
import { goToPreviousPage, pages, goToPage } from '../../states/page/actions';

import { getSelectedFromAccount, getSelectedPaymentId } from '../../states/payeeSelector/selectors';
import { setSelectedFromAccount, clearSelectedPayment } from '../../states/payeeSelector/actions';
import withAccountSelection from '../../containers/withAccountSelection';
import { chapsUpdatePayment } from '../..//states/chaps/actions';
import { iftUpdatePayment } from '../..//states/ift/actions';
import { updateFromAccount as updateFasterPaymentFromAccount } from '../..//states/payments/actions';
import { updateFromAccount as updateBacsCreditFromAccount } from '../..//states/bacsCredit/actions';
import { updateToAccount as updateBacsDebitFromAccount } from '../..//states/bacsDebit/actions';
import { setLCVAccounts } from '../../states/accounts/actions';
import LayoutContainer from '../../pickerLayout/components/LayoutContainer/LayoutContainer';
import { ACCOUNT_PICKER_LAYOUT } from '../../pickerLayout/constants';
import { getFavouriteAccountsForPicker } from '../../states/favourites/selectors';
import { setPagingLayoutType } from '../../states/accountPaging/actions';

const mapState = (state, props) => ({
	selectedPaymentId: getSelectedPaymentId(state),
	selectedFromAccount: getSelectedFromAccount(state),
	toAccounts: getToAccounts(state, props.toAccountFilter),
	fromAccount: getSelectedFromAccount(state),
	favourites: getFavouriteAccountsForPicker(state),
});

const mapDispatch = (dispatch) => ({
	goToPreviousPage: () => dispatch(goToPreviousPage()),
	setPagingLayoutType: (layoutType) => dispatch(setPagingLayoutType(layoutType)),
	handleSelectFromAccount: (account) => dispatch(setSelectedFromAccount(account)),
	setLCVAccountsInAccountList: (accounts) => dispatch(setLCVAccounts(accounts)),
	handleSelectLcvFromAccount: ({ selectedPaymentId, fromAccount, pageId }) => {
		switch (pageId) {
			case pages.FasterPaymentsLandingPage: {
				if (selectedPaymentId) {
					dispatch(updateFasterPaymentFromAccount({ id: selectedPaymentId, accountId: fromAccount }));
					dispatch(goToPage(pages.FasterPayments));
					dispatch(clearSelectedPayment());
				} else {
					dispatch(setSelectedFromAccount(fromAccount));
					dispatch(goToPage(pages.FasterPaymentsPayeeSelector));
				}
				break;
			}
			case pages.IFTLandingPage: {
				if (selectedPaymentId) {
					dispatch(iftUpdatePayment({ id: selectedPaymentId, accountId: fromAccount }));
					dispatch(clearSelectedPayment());
				} else {
					dispatch(setSelectedFromAccount(fromAccount));
				}
				dispatch(goToPage(pages.IFTPayeeSelector));
				break;
			}
			case pages.ChapsLandingPage: {
				if (selectedPaymentId) {
					dispatch(
						chapsUpdatePayment({
							paymentId: selectedPaymentId,
							formKey: 'fromAccount',
							value: fromAccount,
						})
					);
					dispatch(goToPage(pages.ChapsPayments));
					dispatch(clearSelectedPayment());
				} else {
					dispatch(setSelectedFromAccount(fromAccount));
					dispatch(goToPage(pages.ChapsPayeeSelector));
				}
				break;
			}
			case pages.BacsImportedDebitPaymentPage: {
				dispatch(updateBacsDebitFromAccount({ accountId: fromAccount }));
				dispatch(setSelectedFromAccount(fromAccount));
				dispatch(goToPreviousPage());
				break;
			}
			case pages.BacsDebitLanding: {
				dispatch(updateBacsDebitFromAccount({ accountId: fromAccount }));
				dispatch(setSelectedFromAccount(fromAccount));
				if (selectedPaymentId) {
					dispatch(goToPage(pages.BacsDebitPayments));
					dispatch(clearSelectedPayment());
				} else {
					dispatch(goToPage(pages.BacsDebitPayeeSelector));
				}
				break;
			}
			case pages.BacsImportedCreditPaymentPage: {
				dispatch(setSelectedFromAccount(fromAccount));
				dispatch(updateBacsCreditFromAccount({ accountId: fromAccount }));
				dispatch(goToPreviousPage());
				break;
			}
			case pages.BacsCreditLanding: {
				dispatch(setSelectedFromAccount(fromAccount));
				dispatch(updateBacsCreditFromAccount({ accountId: fromAccount }));
				if (selectedPaymentId) {
					dispatch(goToPage(pages.BacsCreditPayments));
					dispatch(clearSelectedPayment());
				} else {
					dispatch(goToPage(pages.BacsCreditPayeeSelector));
				}
				break;
			}
			default:
				break;
		}
	},
});

class AccountPickerPage extends Component {
	constructor(props) {
		super(props);

		this.setSelectedFromAccount = this.setSelectedFromAccount.bind(this);
	}
	componentDidMount() {
		const { setPagingLayoutType } = this.props;
		setPagingLayoutType(ACCOUNT_PICKER_LAYOUT);
	}

	componentWillUnmount() {
		const { setPagingLayoutType } = this.props;
		setPagingLayoutType('');
	}

	setSelectedFromAccount(account) {
		const { selectedPaymentId, handleSelectLcvFromAccount, pageId, setLCVAccountsInAccountList } = this.props;
		setLCVAccountsInAccountList([account]);
		handleSelectLcvFromAccount({ selectedPaymentId, fromAccount: account.id, pageId });
	}

	render() {
		const { favourites, pageId, fromAccount, goToPreviousPage, paymentMode } = this.props;
		return (
			<div className="c-o-payee-list--from-state">
				<SiteHeader title="Account" description={"Choose an account to view it's payment status and history."} />

				<LayoutContainer
					favourites={favourites}
					fromAccount={fromAccount}
					onSelectAccount={(account) => this.setSelectedFromAccount(account)}
					onAddFavourite={() => {}}
					onRemoveFavourite={() => {}}
					pageId={pageId}
					handleGoBack={goToPreviousPage}
					paymentMode={paymentMode}
					isPaymentFlow
				/>
			</div>
		);
	}
}

AccountPickerPage.defaultProps = {};

AccountPickerPage.propTypes = {
	content: PropTypes.shape({}).isRequired,
	selectedPaymentId: PropTypes.string.isRequired,
	handleSelectLcvFromAccount: PropTypes.func.isRequired,
	favourites: PropTypes.shape({}).isRequired,
	pageId: PropTypes.string.isRequired,
	fromAccount: PropTypes.string.isRequired,
	goToPreviousPage: PropTypes.func.isRequired,
	setLCVAccountsInAccountList: PropTypes.func.isRequired,
	setPagingLayoutType: PropTypes.func.isRequired,
	paymentMode: PropTypes.string.isRequired,
};

export default connect(mapState, mapDispatch)(withAccountSelection(AccountPickerPage));
